<template>
  <div class="swiper-pagination" v-if="totalCount != 0">
    <span
      class="bullet"
      :key="i"
      :class="{ on: i == currentPage }"
      v-for="i in maxPage"
    ></span>
  </div>
</template>
<script>
export default {
  name: "mainPaging",
  props: {
    totalCount: Number,
    pageCount: Number,
    currentPage: Number,
  },
  data() {
    return {};
  },
  computed: {
    maxPage() {
      // 총 페이지 수(and 최대 페이지 번호)
      return Math.ceil(this.totalCount / this.pageCount);
    },
  },
  methods: {
    changeCurrentPage(page) {
      // 페이지 변경
      if (this.currentPage !== page) {
        // 변경된 페이지 전송
        this.$emit("changePage", page);
      }
    },
  },
};
</script>

<style src="@/assets/css/style.css" scoped></style>